<template>

    <div>

        <v-data-table
           :headers="headers"
           :items="articles"
           sort-by="gtin"
           :search="search"
           class="elevation-0"
           :loading="isLoading"
           :calculate-widths="true"
           @click:row="rowClick"
           :loading-text="$t('GLOBAL-LOADING-PLEASE_WAIT')">


           <template v-slot:header.item.name="{ header }">
               <lang t="ARTICLES-TBL-HEADER-NAME"></lang>
           </template>

           <template v-slot:header.gtin="{ header }">
               <lang t="ARTICLES-TBL-HEADER-GTIN"></lang>
           </template>

           <template v-slot:header.level="{ header }">
               <lang t="ARTICLES-TBL-HEADER-LEVEL"></lang>
           </template>

           <template v-slot:header.status="{ header }">
               <lang t="ARTICLES-TBL-HEADER-STATUS"></lang>
           </template>

           <template v-slot:header.iso="{ header }">
               <lang t="ARTICLES-TBL-HEADER-ISO"></lang>
           </template>


            <template v-slot:top>

                <div class="d-flex align-center flex-wrap py-2 mb-3">

                    <v-text-field
                        clearable
                        style="max-width: 400px; min-width: 200px;"
                        v-model="search"
                        prepend-inner-icon="mdi-magnify"
                        :label="$t('GLOBAL-DO_SEARCH')"
                        solo
                        flat
                        dense
                        hide-details>
                    </v-text-field>

                </div>

            </template>
    
            <template v-slot:item.status="{ item }">
                <v-chip small label color="orange" outlined text-color="black"><lang :t="'ARTICLE-STATUS-'+(item.status).toUpperCase()"></lang></v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon small @click.stop="editItem(item)">mdi-pencil</v-icon>
            </template>


            <template v-slot:no-data>
                Keine Daten vorhanden
            </template>


         </v-data-table>


         <v-dialog v-model="dialog.show" :max-width="dialog.maxSize + 'px'" :persistent="false">

             <v-card>

                 <v-card-title>
                     <span class="headline"><lang :t="dialog.title"></lang></span>
                 </v-card-title>

             </v-card>


         </v-dialog>

    </div>


</template>

<script>

export default {

    data: () => ({

        dialog: {
            show: false,
            title: '',
            type: ''
        },
        isSaving: false,
        isLoading: true,
        search: '',

        headers: [
            {
                text: 'Name',
                value: 'item.name'
            },
            {
                text: 'GTIN',
                align: 'start',
                sortable: true,
                value: 'gtin',
            },
            { text: 'Hierarchieebene', value: 'level' },
            { text: 'Status', value: 'status' },
            { text: 'ISO', value: 'iso', sortable: false },
            { text: '', value: 'actions', sortable: false, width: "60px"},
        ],

        articles: [],
    }),

    computed: {


    },

    watch: {

        "dialog.show"(val) {
            val || this.closeModal()
        }

    },

    created () {

        this.initialize();

    },


    methods: {

        exportArticles() {


        },

        importArticles() {


        },


        showModal(type) {

            this.dialog.type = type;

            switch(type) {

                case "export":
                    this.dialog.title = "ARTICLES-EXPORT-TITLE";
                    this.dialog.maxSize = "640";
                    break;

                case "import":
                    this.dialog.title = "ARTICLES-IMPORT-TITLE";
                    this.dialog.maxSize = "1024";
                    break;

            }

            this.dialog.show = true;

        },

        closeModal() {

            this.dialog.show = false;

        },


        initialize () {

            this.axios.get('bundles').then(res => {
                this.articles = res.data;
                this.isLoading = false;
            })

        },

        rowClick(item) {

            this.editItem(item);

        },

        editItem (item) {

            this.$router.push({ name: 'article', params: { id: item.id }});

        },

        deleteItem (item) {

            const index = this.articles.indexOf(item)
            confirm('Are you sure you want to delete this item?') && this.articles.splice(index, 1)

        },

    },
}
</script>
